"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KetteEinspeisung = void 0;
var KetteEinspeisung;
(function (KetteEinspeisung) {
    KetteEinspeisung[KetteEinspeisung["mittigeEinspeisung"] = 1] = "mittigeEinspeisung";
    KetteEinspeisung[KetteEinspeisung["Endeinspeisung"] = 2] = "Endeinspeisung";
    KetteEinspeisung[KetteEinspeisung["aussenmittigeEinspeisung"] = 3] = "aussenmittigeEinspeisung";
})(KetteEinspeisung = exports.KetteEinspeisung || (exports.KetteEinspeisung = {}));
//# sourceMappingURL=KetteEinspeisung.js.map